/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../../../banking/account_model';
import '../../../models/account';
import '../../../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "CreateAccountRequest": {
                    "fields": {
                      "idempotencyKey": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "customerId": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "name": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "category": {
                        "type": ".squareup.banking.SavingsAccountMetadata.Category",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  },
                  "CreateAccountResponse": {
                    "fields": {
                      "account": {
                        "type": ".squareup.sfs.models.Account",
                        "id": 1,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": ".squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.CreateAccountRequest && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.CreateAccountResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CreateAccountRequest @ squareup/sfs/external/services/account/create_account.proto at 11:1
 */
export const CreateAccountRequest = $root.lookupType('squareup.sfs.external.service.CreateAccountRequest');
fixType(CreateAccountRequest, {
  idempotencyKey: {
    required: true
  },
  customerId: {
    required: true
  }
});
Builder.createAndAttachToType(CreateAccountRequest);
/**
 * SOURCE CreateAccountResponse @ squareup/sfs/external/services/account/create_account.proto at 37:1
 */
export const CreateAccountResponse = $root.lookupType('squareup.sfs.external.service.CreateAccountResponse');
fixType(CreateAccountResponse, {
  account: {
    required: true
  }
});
Builder.createAndAttachToType(CreateAccountResponse);